module.exports = __webpack_public_path__ + "img/account_circle@3x.1c8681a.png";